module.exports = __webpack_public_path__ + "img/cats5.a499eec5.jpg";